import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  reason?: string;
}

/**
 * Renderizado quando ``GET /observability/status`` retorna
 * ``enabled=false``. UI fica acessivel-mas-desabilitada (nao retorna
 * 404 ou erro), explicando ao admin como habilitar.
 */
export function DisabledBanner({ reason }: Props) {
  const { t } = useTranslation("observability");
  return (
    <div className="rounded-md border border-yellow-300 bg-yellow-50 p-6">
      <div className="flex items-start gap-3">
        <AlertCircle className="mt-1 h-5 w-5 text-yellow-700" />
        <div>
          <h2 className="text-lg font-semibold text-yellow-900">
            {t("disabled.title")}
          </h2>
          <p className="mt-1 text-sm text-yellow-800">{t("disabled.description")}</p>
          {reason ? (
            <p className="mt-2 text-xs font-mono text-yellow-700">{reason}</p>
          ) : null}
          <p className="mt-3 text-xs text-yellow-700">
            Configure: <code>LANGFUSE__ENABLE=true</code>,{" "}
            <code>LANGFUSE__HOST</code>, <code>LANGFUSE__PUBLIC_KEY</code>,{" "}
            <code>LANGFUSE__SECRET_KEY</code> em <code>.env</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
